<template>
  <div>
    <Head title="Mail Settings" />
    <h1>Mail Settings</h1>

    <div class="content-box">
      <h3>Edit Mail Settings</h3>
      <ul>
        <li><Link href="/settings/mail/templates">Mail Templates</Link></li>
        <li><Link href="/settings/mail/inserts">Mail Inserts</Link></li>
        <li><Link href="/settings/mail/pdfs">Mail PDFs</Link></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
    Icon,
    Link
  },
  layout: Layout,
  props: {
  },
  data() {
    return {
    }
  }
}
</script>
